module.exports = __webpack_public_path__ + "static/media/Sort-Desc.88d1d636.svg";